var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "bmui-check_list" },
    _vm._l(_vm.items, function(item, index) {
      return _c("li", { key: index }, [
        _c(
          "label",
          {
            staticClass: "bmui-check_list-item",
            class: { "bmui-check_list-disabled": item.disabled }
          },
          [
            _c("span", { staticClass: "bmui-check_list-text" }, [
              _vm._v(
                _vm._s((typeof item === "string" ? item : item.name) || "ITEM")
              )
            ]),
            _vm._v(" "),
            _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.valueInside,
                      expression: "valueInside"
                    }
                  ],
                  staticClass: "bmui-check_list-input",
                  attrs: { type: "checkbox", disabled: item.disabled },
                  domProps: {
                    value: typeof item === "string" ? item : item.value,
                    checked: Array.isArray(_vm.valueInside)
                      ? _vm._i(
                          _vm.valueInside,
                          typeof item === "string" ? item : item.value
                        ) > -1
                      : _vm.valueInside
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.valueInside,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = typeof item === "string" ? item : item.value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.valueInside = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.valueInside = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.valueInside = $$c
                      }
                    }
                  }
                },
                "input",
                _vm.mixinInputProps,
                false
              )
            )
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87482e04", { render: render, staticRenderFns: staticRenderFns })
  }
}